import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Box,
  Link,
  Button
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Page from '../Page';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead, ClientListToolbar, ClientMoreMenu } from '../_dashboard/clients';
import { useConstantsContext } from '../../context/constants_context';
import { useInvoiceContext } from '../../context/invoice_context';
import { useClientContext } from '../../context/client_context';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';

const TABLE_HEAD = [
  { id: 'productID', label: 'Code', alignRight: false },
  { id: 'productName', label: 'Description', alignRight: false },
  { id: 'units', label: 'Qty', alignRight: false },
  { id: 'sellingPrice', label: 'Selling Price', alignRight: false },
  { id: 'total', label: 'Total', alignRight: false },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.surname.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function InvoiceDetails() {
  // const { clientList } = useConstantsContext();
  const { invoice, state, totalAmount } = useInvoiceContext();
  const { currentClient } = useClientContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('surname');
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = invoice.map((n) => n.surname);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const saveInvoiceData = (inv) => {
    const invoiceData = {
      clientID: currentClient.refId,
      patientId: 1,
      practiceId: '01074',
      invoiceDetails: invoice
    };
    const jsonClient = [];
    jsonClient.push(invoiceData);
    console.log('invoice stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/product/addInvoice`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((result) => result.json())
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            setNotify({
              isOpen: true,
              message: `Error in Creating Invoice!: ${result.errorList[0].errorDescription}`,
              type: 'error'
            });
          } else {
            setNotify({
              isOpen: true,
              message: 'Invoice Created Successfully!',
              type: 'success'
            });
            setSaved(true);
          }
        },
        (error) => {
          alert(`Fata Error in Creating Invoice!${error}`);
        }
      );
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - invoice.length) : 0;
  console.log('client list in client 01', invoice);
  const filteredUsers = applySortFilter(invoice, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;
  console.log('client list in client', invoice);
  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Search Results...
      </Typography>
      <Card>
        {/* <ClientListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        /> */}

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={invoice.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const { productID, productName, units, sellingPrice, total } = row;
                    const isItemSelected = selected.indexOf(productID) !== -1;

                    return (
                      <TableRow
                        hover
                        key={productID}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{productID}</TableCell>
                        <TableCell align="left">{productName}</TableCell>
                        <TableCell align="left">{units}</TableCell>
                        <TableCell align="left">{sellingPrice}</TableCell>
                        <TableCell align="left">{total}</TableCell>
                        <TableCell align="right">
                          <IconButton>
                            <DeleteForeverIcon sx={{ color: '#f44336' }} />
                          </IconButton>
                          <IconButton>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={invoice.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {!!invoice.length && (
        <Box p={2.5}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              mb: '0.75rem',
              height: '40px'
            }}
            fullWidth
            onClick={() => saveInvoiceData()}
          >
            Process Now ($ {totalAmount.toFixed(2)});
            {/* Eita Total */}
          </Button>
        </Box>
      )}
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </Container>
    // </Page>
  );
}
